import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";

import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { actions as afipPaymentsActions } from "reducers/afipPayments";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import { useTransaction } from "hooks/useTransactions";
import Image from "pages/_components/Image";
import gaEventTracker, { events } from "util/gaEventTracker";
import AfipPaymentsSummaryBody from "./components/Summary";

const EmitAfipTransactionPage = (props) => {
    const formatTransaction = (data, idTransaction) => {
        const formData = {
            afipTaxForm: data.afipTaxForm,
            afipPaymentData: { ...data.afipPaymentData, idTransaction },
            afipBarCode: data.afipBarCode,
            afipPaymentPrepare: data.afipPaymentPrepare,
        };
        return { ...formData };
    };

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/afip/newPayment/sumary",
        afipPaymentsActions.relateBuyerToAfipPayment,
        afipPaymentsActions.cleanAfipTicket,
        formatTransaction,
    );
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "afipPayments.newAfip.title",
        id,
        "afipTrasaction",
    );
    const { isFinished, isBackoffice } = status;
    const { isDesktop } = props;
    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleDownload = async () => {
        await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.pagos_servicios_descargar());
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="afipTrasaction" />
            {!isBackoffice && <ResponsiveHeader noBack ticket metaTitle="afipPayments.newAfip.title" />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="afipPayments.newAfip.title" {...props} />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <AfipPaymentsSummaryBody
                                        isRecipt
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__body ticket__full-width">
                                        <div className="ticket__divider inside-ticket__body">
                                            <div className="ticket__notch ticket__notch--left"> </div>
                                            <div className="ticket__notch ticket__notch--right"> </div>
                                        </div>
                                        {isFinished && (
                                            <div className="text-center">
                                                <Image src="images/figma/illustrations/rapipago.svg" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            {!isFinished && (
                                <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                    <Button
                                        onClick={() => dispatch(push("/desktop"))}
                                        label="forms.transaction.ticket.actions.backToHome"
                                        className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                    />
                                </Col>
                            )}
                            {isFinished && (
                                <>
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <Button
                                            image="images/download.svg"
                                            onClick={handleDownload}
                                            label="global.download"
                                            className="btn  btn-outline"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4} mdOffset={2}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={() => dispatch(push("/afip/newPayment"))}
                                            label="afipPayments.newAfip.title"
                                            className="btn  btn-primary"
                                        />
                                    </Col>
                                </>
                            )}
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

EmitAfipTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default EmitAfipTransactionPage;
